import React from 'react';

const StatusBadge = ({ status }) => {
  const getStatusConfig = (status) => {
    const configs = {
      'Pending': { color: 'warning', label: 'Pending' },
      'Qualified': { color: 'primary', label: 'Qualified' },
      'Contacted': { color: 'secondary', label: 'Contacted' },
      'Closed Won': { color: 'success', label: 'Closed Won' },
      'Closed Lost': { color: 'error', label: 'Closed Lost' },
      'Nurturing': { color: 'accent', label: 'Nurturing' },
    };
    return configs?.[status] || { color: 'muted', label: status };
  };

  const config = getStatusConfig(status);

  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-${config?.color}/10 text-${config?.color}`}>
      {config?.label}
    </span>
  );
};

export default StatusBadge;